import React from 'react'
import styled from '@emotion/styled'
import { useRecoilValue, useSetRecoilState } from 'recoil'
import { Check } from '@emotion-icons/material/Check'
import { UserList, UserListItem } from 'src/common-services'
import { Colors, Shapes } from 'src/components/theme'

import * as userListsAtoms from 'src/atoms/user-lists'
import * as userListsPopoverAtoms from 'src/atoms/user-lists/user-lists-popover'

type SavedInProps = {
  readonly place?: UserListItem
}

const StyledWrapper = styled.div`
  display: flex;
  align-items: center;
  margin: ${Shapes.spacing[1]}px 0;
`

const StyledIconWrapper = styled.div`
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  margin-right: 6px;
  border-radius: 10px;
  background-color: ${Colors.tealDark};
`

const StyledLabel = styled.span`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  color: ${Colors.tealDark};

  a {
    cursor: pointer;
    color: ${Colors.blueDark};
    text-decoration: underline;

    &:active {
      color: ${Colors.blueMedium};
    }
  }
`

const savedInText = (lists: UserList[]) => {
  if (lists.length === 1) {
    return lists[0].name
  }
  return `${lists.length} lists`
}

export const SavedIn: React.FC<SavedInProps> = ({ place }) => {
  const setUserListsPopoverAnchorElement = useSetRecoilState(userListsPopoverAtoms.anchorElement)
  const setUserListsPopoverPosition = useSetRecoilState(userListsPopoverAtoms.position)
  const userListItem = useRecoilValue(userListsAtoms.userListItem)
  const savedIn = useRecoilValue(userListsAtoms.savedIn(place || userListItem))

  if (savedIn.length === 0) {
    return null
  }

  const handleOpenSavedIn = (evt: React.MouseEvent<HTMLElement>) => {
    setUserListsPopoverPosition({ vertical: 20, horizontal: -20 })
    setUserListsPopoverAnchorElement(evt.currentTarget)
  }

  return (
    <StyledWrapper>
      <StyledIconWrapper>
        <Check color={Colors.bgWhite} size={12} />
      </StyledIconWrapper>
      <StyledLabel>
        Saved in <a onClick={handleOpenSavedIn}>{savedInText(savedIn)}</a>
      </StyledLabel>
    </StyledWrapper>
  )
}
